module.exports = __webpack_public_path__ + "img/img16.19e3778f.jpg";